document.addEventListener('DOMContentLoaded', function() {
  // Force override footer fonts with JavaScript
  const newsletterTitle = document.querySelectorAll('.custom-newsletter-title');
  if (newsletterTitle.length > 0) {
    newsletterTitle.forEach(el => {
      el.style.setProperty('font-family', "'Cormorant Garamond', serif", 'important');
      el.style.setProperty('font-size', '26px', 'important');
      el.style.setProperty('font-weight', '400', 'important');
      el.style.setProperty('color', 'white', 'important');
      el.style.setProperty('margin-bottom', '15px', 'important');
    });
  }
  
  const newsletterText = document.querySelectorAll('.custom-newsletter-text');
  if (newsletterText.length > 0) {
    newsletterText.forEach(el => {
      el.style.setProperty('font-family', "'Montserrat', sans-serif", 'important');
      el.style.setProperty('font-size', '14px', 'important');
      el.style.setProperty('color', 'rgba(255, 255, 255, 0.9)', 'important');
      el.style.setProperty('margin-bottom', '20px', 'important');
    });
  }
});